<div class="page-container online-users-page" testId="online-users-page">
  <div class="search-section" testId="online-users-search-section">
    <div class="online-users-header">
      <div>
        <div class="online-users-eyebrow">{{ 'socketio.audit.online-sidebar.eyebrow' | i18n }}</div>
        <h2>{{ 'route.socketio-online-users' | i18n }}</h2>
        <p>{{ 'socketio.audit.online-sidebar.description' | i18n }}</p>
      </div>
      <div class="online-users-stat" testId="online-users-stat">
        <span>{{ 'dashboard.online-user-count' | i18n }}</span>
        <strong>{{ onlineUserTotal }}</strong>
      </div>
    </div>

    <div class="online-users-toolbar">
      <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" testId="online-users-search-input-group">
        <input
          type="text"
          nz-input
          [placeholder]="'socketio.audit.online-sidebar.search-placeholder' | i18n"
          [(ngModel)]="searchKey"
          (keyup.enter)="search()"
          testId="online-users-search-input"
        />
        <ng-template #suffixIconSearch>
          <i nz-icon nzType="search" (click)="search()" class="search-icon" testId="online-users-search-icon"></i>
        </ng-template>
      </nz-input-group>

      <div class="online-users-actions">
        <button nz-button nzType="default" type="button" (click)="reset()" testId="online-users-reset-button">
          {{ 'common.reset' | i18n }}
        </button>
        <button nz-button nzType="default" type="button" (click)="refresh()" testId="online-users-refresh-button">
          {{ 'common.refresh' | i18n }}
        </button>
      </div>
    </div>
  </div>

  <div class="table-section" testId="online-users-table-section">
    <div class="table-scroll-shell" testId="online-users-table-scroll-shell">
      <nz-table
        #onlineUsersTable
        class="content-table"
        [nzData]="onlineUsers"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        [nzLoading]="loading"
        nzSize="small"
        [nzScroll]="{ x: tableScrollX, y: 'calc(100vh - 360px)' }"
        testId="online-users-table"
      >
        <thead>
          <tr testId="online-users-table-header">
            <th scope="col" nzWidth="60px" nzLeft class="text-center row-number-column" testId="online-users-serial-header">
              {{ 'common.serial-number' | i18n }}
            </th>
            <th scope="col" *ngFor="let column of columns" [nzWidth]="column.width" [testId]="'online-users-header-' + column.key">
              {{ column.title }}
            </th>
            <th scope="col" nzWidth="96px" nzRight class="actions-column" testId="online-users-actions-header">
              {{ 'common.actions' | i18n }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of onlineUsersTable.data; let i = index" (dblclick)="viewAccount(data)" [testId]="'online-users-row-' + i">
            <td nzLeft class="text-center row-number-column" testId="online-users-serial-cell">{{ i + 1 }}</td>
            <td testId="online-users-cell-updateTime">
              <span class="time-text" [title]="data.updateTime ? (data.updateTime | date: 'yyyy-MM-dd HH:mm:ss') : '--'">
                {{ data.updateTime ? (data.updateTime | date: 'yyyy-MM-dd HH:mm:ss') : '--' }}
              </span>
            </td>
            <td testId="online-users-cell-accountId">
              <span class="truncate-text mono-text account-id-text" [title]="data.accountId">{{ data.accountId || '--' }}</span>
            </td>
            <td testId="online-users-cell-name">
              <span class="truncate-text" [title]="data.name">{{ data.name || '--' }}</span>
            </td>
            <td testId="online-users-cell-mobile">
              <span class="truncate-text" [title]="getMobileDisplay(data)">{{ getMobileDisplay(data) }}</span>
            </td>
            <td testId="online-users-cell-channel">
              <span class="truncate-text" [title]="data.channel">{{ data.channel || '--' }}</span>
            </td>
            <td testId="online-users-cell-osType">
              <span class="truncate-text" [title]="getOsTypeDisplay(data)">{{ getOsTypeDisplay(data) }}</span>
            </td>
            <td testId="online-users-cell-loginMethod">
              <span class="truncate-text" [title]="getLoginMethodDisplay(data)">{{ getLoginMethodDisplay(data) }}</span>
            </td>
            <td testId="online-users-cell-tokenId">
              <div class="token-cell">
                <span class="truncate-text mono-text" [title]="data.tokenId">{{ getTokenPreview(data.tokenId) }}</span>
                <span class="token-actions" *ngIf="data.tokenId && data.tokenId !== '--'">
                  <a
                    (click)="openTokenModal(data.tokenId); $event.stopPropagation()"
                    class="view-link"
                    testId="online-users-token-view-link"
                  >
                    {{ 'common.view' | i18n }}
                  </a>
                  <a (click)="copyToken(data.tokenId, $event)" class="view-link" testId="online-users-token-copy-link">
                    {{ 'socketio.audit.online-sidebar.copy-token' | i18n }}
                  </a>
                </span>
              </div>
            </td>
            <td nzRight class="actions-column" testId="online-users-actions-cell">
              <a (click)="viewAccount(data)" class="view-link" testId="online-users-view-link">{{ 'common.view' | i18n }}</a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>

  <div class="pagination-section" *ngIf="onlineUserTotal > 0" testId="online-users-pagination-section">
    <div class="pagination-info" testId="online-users-pagination-info">{{ 'common.total-records' | i18n: { total: onlineUserTotal } }}</div>
    <div class="pagination-controls">
      <nz-pagination
        nzSize="small"
        [nzShowQuickJumper]="true"
        [nzPageIndex]="pageIndex"
        [nzTotal]="onlineUserTotal"
        [nzPageSize]="pageSize"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]"
        (nzPageIndexChange)="nzPageIndexChange($event)"
        (nzPageSizeChange)="nzPageSizeChange($event)"
        testId="online-users-pagination"
      />
    </div>
  </div>
</div>

<nz-modal
  [nzVisible]="tokenModalVisible"
  [nzClosable]="true"
  [nzMaskClosable]="true"
  [nzFooter]="null"
  [nzWidth]="640"
  nzTitle=" "
  (nzOnCancel)="closeTokenModal()"
  testId="online-users-token-modal"
>
  <ng-container *nzModalContent>
    <section class="audit-drawer-shell">
      <header class="audit-drawer-header">
        <div>
          <span class="audit-drawer-eyebrow">{{ 'socketio.audit.online-sidebar.token' | i18n }}</span>
          <h2>{{ 'socketio.audit.online-sidebar.token-detail' | i18n }}</h2>
        </div>
      </header>

      <section class="event-payload-card">
        <div class="event-payload-title">{{ 'socketio.audit.online-sidebar.token' | i18n }}</div>
        <pre class="event-payload-content mono-text">{{ selectedToken || '--' }}</pre>
        <div class="token-modal-actions">
          <button nz-button nzType="default" type="button" (click)="copyToken(selectedToken)" testId="online-users-token-modal-copy">
            {{ 'socketio.audit.online-sidebar.copy-token' | i18n }}
          </button>
        </div>
      </section>
    </section>
  </ng-container>
</nz-modal>

<nz-modal
  [nzVisible]="auditModalVisible"
  [nzClosable]="true"
  [nzMaskClosable]="true"
  [nzFooter]="null"
  [nzWidth]="1520"
  nzTitle=" "
  (nzOnCancel)="closeAuditModal()"
  testId="online-users-audit-modal"
>
  <ng-container *nzModalContent>
    <section class="audit-drawer-shell">
      <header class="audit-drawer-header">
        <div>
          <span class="audit-drawer-eyebrow">{{ 'socketio.audit.drawer.eyebrow' | i18n }}</span>
          <h2>{{ auditModalTitle }}</h2>
          <p>{{ 'socketio.audit.drawer.subtitle' | i18n }}</p>
        </div>
        <button
          *ngIf="auditAllEventKey"
          nz-button
          nzType="default"
          type="button"
          class="audit-all-events-button"
          (click)="viewAllAuditEvents()"
          testId="online-users-audit-all-events-button"
        >
          {{ 'socketio.audit.events.all' | i18n }}
        </button>
      </header>

      <nz-spin [nzSpinning]="auditModalLoading" testId="online-users-audit-spin">
        <section class="audit-summary-bar" testId="online-users-audit-summary">
          <div class="audit-summary-item">
            <span>{{ 'account.list.account-id' | i18n }}</span>
            <strong class="mono-text">{{ auditAccountId || '--' }}</strong>
          </div>
          <div class="audit-summary-item">
            <span>{{ 'account.list.phone-number' | i18n }}</span>
            <strong>{{ auditContext.mobileDisplay || '--' }}</strong>
          </div>
          <div class="audit-summary-item">
            <span>{{ 'account.list.account-source' | i18n }}</span>
            <strong>{{ auditContext.channel || '--' }}</strong>
          </div>
          <div class="audit-summary-item">
            <span>{{ 'socketio.audit.online-sidebar.os-type' | i18n }}</span>
            <strong>{{ auditContext.osType || '--' }}</strong>
          </div>
          <div class="audit-summary-item">
            <span>{{ 'socketio.audit.online-sidebar.login-method' | i18n }}</span>
            <strong>{{ auditContext.loginMethod || '--' }}</strong>
          </div>
          <div class="audit-summary-item">
            <span>{{ 'socketio.audit.online-sidebar.login-time' | i18n }}</span>
            <strong>{{ auditContext.loginTime ? (auditContext.loginTime | date: 'yyyy-MM-dd HH:mm:ss') : '--' }}</strong>
          </div>
          <div class="audit-summary-item">
            <span>{{ 'socketio.audit.drawer.online-connection-count' | i18n }}</span>
            <strong>{{ connectedAuditCount }} / {{ auditTotal }}</strong>
          </div>
        </section>

        <div class="audit-filter-bar">
          <input
            nz-input
            [(ngModel)]="auditFilters.sid"
            [placeholder]="'socketio.audit.filter.sid' | i18n"
            (keyup.enter)="searchAuditLogs()"
            testId="online-users-audit-filter-sid"
          />
          <input
            nz-input
            [(ngModel)]="auditFilters.key"
            [placeholder]="'socketio.audit.filter.key' | i18n"
            (keyup.enter)="searchAuditLogs()"
            testId="online-users-audit-filter-key"
          />
          <nz-select
            [(ngModel)]="auditFilters.connected"
            [nzPlaceHolder]="'socketio.audit.filter.status' | i18n"
            nzAllowClear
            testId="online-users-audit-filter-status"
          >
            <nz-option nzValue="true" [nzLabel]="'socketio.audit.drawer.connected' | i18n" />
            <nz-option nzValue="false" [nzLabel]="'socketio.audit.drawer.disconnected' | i18n" />
          </nz-select>
          <input
            nz-input
            [(ngModel)]="auditFilters.disconnectReason"
            [placeholder]="'socketio.audit.filter.disconnect-reason' | i18n"
            (keyup.enter)="searchAuditLogs()"
            testId="online-users-audit-filter-disconnect-reason"
          />
          <input
            nz-input
            [(ngModel)]="auditFilters.uniqueId"
            [placeholder]="'socketio.audit.filter.unique-id' | i18n"
            (keyup.enter)="searchAuditLogs()"
            testId="online-users-audit-filter-uniqueId"
          />
          <button nz-button nzType="primary" type="button" (click)="searchAuditLogs()" testId="online-users-audit-search-button">
            {{ 'common.search' | i18n }}
          </button>
          <button nz-button nzType="default" type="button" (click)="resetAuditFilters()" testId="online-users-audit-reset-button">
            {{ 'common.reset' | i18n }}
          </button>
        </div>

        <ng-container *ngIf="auditLogs.length; else auditEmptyTpl">
          <div class="audit-list-panel">
            <div class="audit-table-shell">
              <nz-table
                #auditTable
                class="audit-log-table"
                [nzData]="auditLogs"
                [nzFrontPagination]="false"
                [nzShowPagination]="false"
                nzSize="small"
                [nzScroll]="{ x: '1560px', y: '420px' }"
                testId="online-users-audit-table"
              >
                <thead>
                  <tr>
                    <th nzWidth="64px" testId="online-users-audit-header-index">{{ 'common.serial-number' | i18n }}</th>
                    <th nzWidth="170px" testId="online-users-audit-header-connect-time">{{ 'account.list.create-time' | i18n }}</th>
                    <th nzWidth="170px" testId="online-users-audit-header-disconnect-time">{{
                      'socketio.audit.drawer.disconnect-time' | i18n
                    }}</th>
                    <th nzWidth="220px" testId="online-users-audit-header-sid">{{ 'socketio.audit.field.sid' | i18n }}</th>
                    <th nzWidth="180px" testId="online-users-audit-header-key">{{ 'socketio.audit.drawer.key' | i18n }}</th>
                    <th nzWidth="110px" testId="online-users-audit-header-status">{{ 'socketio.audit.filter.status' | i18n }}</th>
                    <th nzWidth="170px" testId="online-users-audit-header-disconnect-reason">{{
                      'socketio.audit.drawer.disconnect-reason' | i18n
                    }}</th>
                    <th nzWidth="110px" testId="online-users-audit-header-duration">{{ 'socketio.audit.drawer.duration' | i18n }}</th>
                    <th nzWidth="200px" testId="online-users-audit-header-device">{{ 'socketio.audit.drawer.device' | i18n }}</th>
                    <th nzWidth="220px" testId="online-users-audit-header-unique-id">{{ 'log.device-id' | i18n }}</th>
                    <th nzWidth="100px" testId="online-users-audit-header-os-type">{{ 'socketio.audit.online-sidebar.os-type' | i18n }}</th>
                    <th nzWidth="120px" testId="online-users-audit-header-channel">{{ 'account.list.account-source' | i18n }}</th>
                    <th nzWidth="130px" testId="online-users-audit-header-ip">{{ 'socketio.audit.drawer.ip' | i18n }}</th>
                    <th nzWidth="100px" nzRight testId="online-users-audit-header-actions">{{ 'common.actions' | i18n }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let log of auditTable.data; let i = index" [testId]="'online-users-audit-log-' + i">
                    <td [testId]="'online-users-audit-cell-index-' + i">{{ (auditPageIndex - 1) * auditPageSize + i + 1 }}</td>
                    <td [testId]="'online-users-audit-cell-connect-time-' + i">{{
                      log.connectTime ? (log.connectTime | date: 'yyyy-MM-dd HH:mm:ss') : '--'
                    }}</td>
                    <td [testId]="'online-users-audit-cell-disconnect-time-' + i">{{
                      log.disconnectTime ? (log.disconnectTime | date: 'yyyy-MM-dd HH:mm:ss') : '--'
                    }}</td>
                    <td [testId]="'online-users-audit-cell-sid-' + i"
                      ><span class="truncate-text mono-text" [title]="log.sid">{{ log.sid || '--' }}</span></td
                    >
                    <td [testId]="'online-users-audit-cell-key-' + i"
                      ><span class="truncate-text mono-text" [title]="log.key">{{ log.key || '--' }}</span></td
                    >
                    <td [testId]="'online-users-audit-cell-status-' + i">
                      <span class="audit-status-chip" [class.is-online]="log.connected" [class.is-offline]="!log.connected">
                        {{ getAuditStatusLabel(log) }}
                      </span>
                    </td>
                    <td [testId]="'online-users-audit-cell-disconnect-reason-' + i"
                      ><span class="truncate-text" [title]="log.disconnectReason">{{ log.disconnectReason || '--' }}</span></td
                    >
                    <td [testId]="'online-users-audit-cell-duration-' + i">{{ getAuditDurationDisplay(log.durationMs) }}</td>
                    <td [testId]="'online-users-audit-cell-device-' + i"
                      ><span class="truncate-text" [title]="getAuditDeviceDisplay(log)">{{ getAuditDeviceDisplay(log) }}</span></td
                    >
                    <td [testId]="'online-users-audit-cell-unique-id-' + i"
                      ><span class="truncate-text mono-text" [title]="log.uniqueId">{{ log.uniqueId || '--' }}</span></td
                    >
                    <td [testId]="'online-users-audit-cell-os-type-' + i"
                      ><span class="truncate-text" [title]="log.osType">{{ log.osType || '--' }}</span></td
                    >
                    <td [testId]="'online-users-audit-cell-channel-' + i"
                      ><span class="truncate-text" [title]="getAuditChannelDisplay(log)">{{ getAuditChannelDisplay(log) }}</span></td
                    >
                    <td [testId]="'online-users-audit-cell-ip-' + i"
                      ><span class="truncate-text mono-text" [title]="log.deviceIp">{{ log.deviceIp || '--' }}</span></td
                    >
                    <td nzRight [testId]="'online-users-audit-cell-actions-' + i">
                      <a (click)="viewAuditEvents(log)" class="view-link" testId="online-users-audit-events-link">
                        {{ 'socketio.audit.events.view' | i18n }}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
            </div>

            <div class="audit-pagination">
              <div class="audit-pagination-info">{{ 'common.total-records' | i18n: { total: auditTotal } }}</div>
              <nz-pagination
                [nzPageIndex]="auditPageIndex"
                [nzTotal]="auditTotal"
                [nzPageSize]="auditPageSize"
                [nzShowSizeChanger]="true"
                [nzPageSizeOptions]="[10, 20, 50]"
                [nzSimple]="true"
                (nzPageIndexChange)="onAuditPageIndexChange($event)"
                (nzPageSizeChange)="onAuditPageSizeChange($event)"
                testId="online-users-audit-pagination"
              />
            </div>
          </div>
        </ng-container>
      </nz-spin>
    </section>
  </ng-container>
</nz-modal>

<ng-template #auditEmptyTpl>
  <div class="audit-empty-wrap" testId="online-users-audit-empty">
    {{ 'socketio.audit.drawer.empty' | i18n }}
  </div>
</ng-template>

<nz-modal
  [nzVisible]="eventModalVisible"
  [nzClosable]="true"
  [nzMaskClosable]="true"
  [nzFooter]="null"
  [nzWidth]="1120"
  nzTitle=" "
  (nzOnCancel)="closeEventModal()"
  testId="online-users-event-modal"
>
  <ng-container *nzModalContent>
    <section class="audit-drawer-shell">
      <header class="audit-drawer-header">
        <div>
          <span class="audit-drawer-eyebrow">{{ 'socketio.audit.events.eyebrow' | i18n }}</span>
          <h2>{{ eventModalTitle || ('socketio.audit.events.title' | i18n) }}</h2>
          <p>{{ 'socketio.audit.events.subtitle' | i18n }}</p>
        </div>
      </header>

      <nz-spin [nzSpinning]="eventModalLoading" testId="online-users-event-spin">
        <section class="audit-summary-bar" testId="online-users-event-summary">
          <div class="audit-summary-item">
            <span testId="online-users-event-summary-sid-label">{{ 'socketio.audit.field.sid' | i18n }}</span>
            <strong class="mono-text">{{ eventTargetSid || '--' }}</strong>
          </div>
          <div class="audit-summary-item">
            <span>{{ 'socketio.audit.drawer.key' | i18n }}</span>
            <strong class="mono-text">{{ eventTargetKey || '--' }}</strong>
          </div>
          <div class="audit-summary-item">
            <span>{{ 'common.total-records' | i18n: { total: eventLogs.length } }}</span>
            <strong>{{ eventLogs.length }}</strong>
          </div>
        </section>

        <ng-container *ngIf="eventLogs.length; else eventEmptyTpl">
          <div class="audit-table-shell">
            <nz-table
              #eventTable
              class="audit-log-table"
              [nzData]="eventLogs"
              [nzFrontPagination]="false"
              [nzShowPagination]="false"
              nzSize="small"
              [nzScroll]="{ x: '920px', y: '340px' }"
              testId="online-users-event-table"
            >
              <thead>
                <tr>
                  <th nzWidth="72px" testId="online-users-event-header-sequence">{{ 'socketio.audit.events.sequence' | i18n }}</th>
                  <th nzWidth="132px" testId="online-users-event-header-name">{{ 'socketio.audit.events.name' | i18n }}</th>
                  <th nzWidth="112px" testId="online-users-event-header-code">{{ 'socketio.audit.events.code' | i18n }}</th>
                  <th nzWidth="160px" testId="online-users-event-header-message-id">{{ 'socketio.audit.events.message-id' | i18n }}</th>
                  <th nzWidth="120px" testId="online-users-event-header-delivery">{{ 'socketio.audit.events.delivery' | i18n }}</th>
                  <th nzWidth="120px" testId="online-users-event-header-payload">{{ 'socketio.audit.events.payload' | i18n }}</th>
                  <th nzWidth="92px" testId="online-users-event-header-actions">{{ 'common.actions' | i18n }}</th>
                  <th nzWidth="160px" testId="online-users-event-header-create-time">{{ 'account.list.create-time' | i18n }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let event of eventTable.data; let i = index"
                  class="event-row"
                  (click)="viewEventDetail(event)"
                  [testId]="'online-users-event-row-' + i"
                >
                  <td [testId]="'online-users-event-cell-sequence-' + i">{{ event.sequence ?? '--' }}</td>
                  <td [testId]="'online-users-event-cell-name-' + i"
                    ><span class="truncate-text" [title]="event.eventName">{{ event.eventName || '--' }}</span></td
                  >
                  <td [testId]="'online-users-event-cell-code-' + i"
                    ><span class="truncate-text" [title]="event.eventCode">{{ event.eventCode || '--' }}</span></td
                  >
                  <td [testId]="'online-users-event-cell-message-id-' + i"
                    ><span class="truncate-text mono-text" [title]="event.messageId">{{ event.messageId || '--' }}</span></td
                  >
                  <td [testId]="'online-users-event-cell-delivery-' + i"
                    ><span class="truncate-text" [title]="getEventDeliveryLabel(event)">{{ getEventDeliveryLabel(event) }}</span></td
                  >
                  <td [testId]="'online-users-event-cell-payload-' + i"
                    ><span class="truncate-text" [title]="event.event">{{ event.event || '--' }}</span></td
                  >
                  <td [testId]="'online-users-event-cell-actions-' + i">
                    <a (click)="viewEventDetail(event); $event.stopPropagation()" class="view-link" testId="online-users-event-detail-link">
                      {{ 'common.view' | i18n }}
                    </a>
                  </td>
                  <td [testId]="'online-users-event-cell-create-time-' + i">{{
                    event.createTime ? (event.createTime | date: 'yyyy-MM-dd HH:mm:ss') : '--'
                  }}</td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </ng-container>
      </nz-spin>
    </section>
  </ng-container>
</nz-modal>

<ng-template #eventEmptyTpl>
  <div class="audit-empty-wrap" testId="online-users-event-empty">
    {{ 'socketio.audit.events.empty' | i18n }}
  </div>
</ng-template>

<nz-modal
  [nzVisible]="eventDetailVisible"
  [nzClosable]="true"
  [nzMaskClosable]="true"
  [nzFooter]="null"
  [nzWidth]="920"
  nzTitle=" "
  (nzOnCancel)="closeEventDetail()"
  testId="online-users-event-detail-modal"
>
  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="eventDetailLoading" testId="online-users-event-detail-spin">
      <section class="audit-drawer-shell" *ngIf="selectedEvent as event">
        <header class="audit-drawer-header">
          <div>
            <span class="audit-drawer-eyebrow">{{ 'socketio.audit.events.detail-eyebrow' | i18n }}</span>
            <h2>{{ event.eventName || ('socketio.audit.events.title' | i18n) }}</h2>
            <p>{{ 'socketio.audit.events.detail-subtitle' | i18n }}</p>
          </div>
        </header>

        <section class="event-detail-grid event-detail-grid-compact">
          <div class="event-detail-compact-card">
            <div class="event-detail-compact-item">
              <span>{{ 'socketio.audit.events.sequence' | i18n }}</span>
              <strong>{{ selectedEventDetail?.socketioSequence ?? selectedEventDetail?.sequence ?? event.sequence ?? '--' }}</strong>
            </div>
            <div class="event-detail-compact-item">
              <span>{{ 'socketio.audit.events.code' | i18n }}</span>
              <strong>{{ selectedEventDetail?.eventCode || event.eventCode || '--' }}</strong>
            </div>
            <div class="event-detail-compact-item">
              <span testId="online-users-event-detail-sid-label">{{ 'socketio.audit.field.sid' | i18n }}</span>
              <strong class="mono-text">{{ selectedEventDetail?.socketioSessionId || event.sid || '--' }}</strong>
            </div>
            <div class="event-detail-compact-item">
              <span>{{ 'log.node' | i18n }}</span>
              <strong>{{ getEventNodeDisplay(selectedEventDetail || event) }}</strong>
            </div>
          </div>

          <div class="event-detail-compact-card event-status-card">
            <div class="event-status-group-title" testId="online-users-event-detail-delivery-title">{{
              'socketio.audit.delivery.status-title' | i18n
            }}</div>
            <div class="event-status-items">
              <div class="event-status-item">
                <span testId="online-users-event-detail-socketio-label">{{ 'socketio.audit.delivery.socketio' | i18n }}</span>
                <strong>{{ getEventSocketioStatusDisplay(selectedEventDetail || event) }}</strong>
              </div>
              <div class="event-status-item">
                <span testId="online-users-event-detail-offline-label">{{ 'socketio.audit.delivery.offline-message' | i18n }}</span>
                <strong>{{ getEventOfflineMessageStatusDisplay(selectedEventDetail || event) }}</strong>
              </div>
              <div class="event-status-item">
                <span testId="online-users-event-detail-push-label">{{ 'socketio.audit.delivery.push' | i18n }}</span>
                <strong>{{ getEventPushStatusDisplay(selectedEventDetail || event) }}</strong>
              </div>
            </div>
          </div>

          <div class="event-detail-compact-card event-detail-wide">
            <div class="event-detail-compact-item">
              <span>{{ 'socketio.audit.events.message-id' | i18n }}</span>
              <strong class="mono-text">{{ event.messageId || '--' }}</strong>
            </div>
            <div class="event-detail-compact-item">
              <span>{{ 'account.list.create-time' | i18n }}</span>
              <strong>{{
                selectedEventDetail?.createTime || event.createTime
                  ? (selectedEventDetail?.createTime || event.createTime | date: 'yyyy-MM-dd HH:mm:ss')
                  : '--'
              }}</strong>
            </div>
            <div class="event-detail-compact-item">
              <span testId="online-users-event-detail-trace-id-label">{{ 'socketio.audit.field.trace-id' | i18n }}</span>
              <strong class="mono-text">{{ getEventTraceIdDisplay(selectedEventDetail) }}</strong>
            </div>
          </div>
        </section>
        <section class="event-payload-card" testId="online-users-event-detail-delivery-card">
          <div class="event-payload-title" testId="online-users-event-detail-delivery-card-title">{{
            'socketio.audit.events.delivery-detail' | i18n
          }}</div>
          <pre class="event-payload-content mono-text">{{ getEventRawMessageDisplay(selectedEventDetail || event) }}</pre>
        </section>

        <section class="event-payload-card" testId="online-users-event-detail-raw-card">
          <div class="event-payload-title" testId="online-users-event-detail-raw-card-title">{{
            'socketio.audit.events.raw-message' | i18n
          }}</div>
          <pre class="event-payload-content mono-text">{{ getEventRecordDisplay(selectedEventDetail || event) }}</pre>
        </section>
      </section>
    </nz-spin>
  </ng-container>
</nz-modal>
